const local =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const runtimeConfig = {
  publicOrigin: "https://mdt.hydeck.net",
  authOrigin:
    import.meta.env.VITE_MDT_AUTH_ORIGIN ||
    (local ? "http://localhost:4100" : "https://hydeck.net/api/mdt"),
  apiOrigin:
    import.meta.env.VITE_MDT_API_ORIGIN ||
    (local ? "http://localhost:4100" : "https://api.mdt.hydeck.net"),
  wsOrigin:
    import.meta.env.VITE_MDT_WS_ORIGIN ||
    (local ? "ws://localhost:4100/ws/" : "wss://api.mdt.hydeck.net/ws/"),
  // The dump reserves /ws/ for Hocuspocus/Yjs binary collaboration. Keep
  // application resource notifications on a separate JSON websocket so the
  // two wire protocols cannot consume each other's frames.
  realtimeOrigin:
    import.meta.env.VITE_MDT_REALTIME_ORIGIN ||
    (local
      ? "ws://localhost:4100/realtime/"
      : ((import.meta.env.VITE_MDT_WS_ORIGIN ||
          "wss://api.mdt.hydeck.net/ws/") as string).replace(
          /\/ws\/?$/,
          "/realtime/",
        )),
  enableDevLogin:
    import.meta.env.DEV && import.meta.env.VITE_ENABLE_DEV_LOGIN !== "false",
  assetOrigin:
    import.meta.env.VITE_MDT_ASSET_ORIGIN ||
    "https://assets.nopixel.net/dev/images/mdt",
};
